export type NewsProviderId =
  | 'BBC'
  | 'Tagesschau'
  | 'GNN'
  | 'PositiveNews'
  | 'R2BC';
export type NewsProviderFilter = NewsProviderId | 'all';

export type NewsProvider = {
  id: NewsProviderId;
  name: string;
  icon: string;
  description: string;
};

export type NewsProviderOption<TValue extends string = string> = {
  label: string;
  value: TValue;
};

export const NEWS_PROVIDERS: readonly NewsProvider[] = [
  // English sources (alphabetical)
  {
    id: 'BBC',
    name: 'BBC World News',
    icon: '🇬🇧',
    description:
      'British Broadcasting Corporation - Global news with a British perspective',
  },
  {
    id: 'GNN',
    name: 'Good News Network',
    icon: '🇬🇧',
    description:
      'Good News Network - Curated positive news from around the world',
  },
  {
    id: 'PositiveNews',
    name: 'Positive.News',
    icon: '🇬🇧',
    description: 'Positive.News - Independent media for positive change',
  },
  {
    id: 'R2BC',
    name: 'Reasons to be Cheerful',
    icon: '🇬🇧',
    description: 'Reasons to be Cheerful - Solutions-focused journalism',
  },
  // German sources
  {
    id: 'Tagesschau',
    name: 'Tagesschau',
    icon: '🇩🇪',
    description:
      'German public broadcaster - Comprehensive news from Germany and the world',
  },
];

export const NEWS_PROVIDER_FILTER_OPTIONS: NewsProviderOption<NewsProviderFilter>[] =
  [
    { value: 'all', label: 'All Sources' },
    ...NEWS_PROVIDERS.map((provider) => ({
      value: provider.id,
      label: provider.id,
    })),
  ];
